import React from "react"
import { Link } from "react-router-dom"
import Section from "../template-parts/product-marketing/Section"

import TopLocations from "../template-parts/TopLocations"

const Locations = () => (
  <Section
    head="Serving Thousands of Cities in Eight States Across America"
    className="section-highlight"
  >
    <TopLocations linkColor="white" />
    <div
      className="location-search"
      style={{ margin: "0 auto", maxWidth: 500, marginTop: 40 }}
    >
      <div style={{ marginTop: 20, textAlign: "center" }}>
        <Link to="/locations" style={{ color: "white" }}>
          Browse All Coastline Locations
        </Link>
      </div>
    </div>
  </Section>
)

export default Locations
